import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useSettings } from '@/providers/SettingsProvider';
import { AppRouting } from '@/routing';
import { PathnameProvider } from '@/providers';
import { Toaster } from '@/components/ui/sonner';
import { ConfigProvider } from 'antd';
import { antdTheme } from '@/config/antd.config';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const {
  BASE_URL
} = import.meta.env;
const App = () => {
  const { settings } = useSettings();

  useEffect(() => {
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.remove('light');
    document.documentElement.classList.add(settings.themeMode);
  }, [settings]);
  return <BrowserRouter basename={BASE_URL} future={{
    v7_relativeSplatPath: true,
    v7_startTransition: true
  }}>
      <PathnameProvider>
        <AppRouting />
      </PathnameProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Toaster />
    </BrowserRouter>;

};

export { App };